import { useEffect, useRef, useState } from "react";
import landingVid from "../Videos/landing_vid.mp4";

const MarketingVideo = () => {
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isMuted, setIsMuted] = useState(true); // Start muted

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.intersectionRatio > 0.25); // Play at 25% visibility
      },
      { threshold: 0.25 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handlePlay = async () => {
      try {
        if (isVisible) {
          if (video.paused) {
            await video.play();
          }
        } else {
          if (!video.paused) {
            video.pause();
          }
        }
      } catch (err) {
        console.error("Error playing video:", err);
      }
    };

    handlePlay();
  }, [isVisible]);

  // Allow user to unmute the video manually
  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center p-8">
      <div className="relative rounded-xl bg-[#1A1D26] p-3 shadow-[0px_0px_40px_rgba(128,90,213,0.5)]">
        <video
          ref={videoRef}
          className="rounded-lg shadow-lg shadow-indigo-500/50"
          width="800"
          loop
          playsInline
          controls
          muted={isMuted} // Start muted
        >
          <source src={landingVid} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default MarketingVideo;
